import { create } from "zustand";
import { getContacts } from "../services/contact_service";
import { getAccounts } from "../services/account_service";

const useLookupStore = create((set, get) => ({
  contacts: [],
  accounts: [],
  accountsHydrated: false,
  accountsLoading: false,
  accountsError: "",
  hydrated: false,
  loading: false,
  error: "",

  hydrateLookups: async () => {
    if (get().loading || get().hydrated) {
      return;
    }

    set({ loading: true, error: "" });

    try {
      const [contactData, accountData] = await Promise.all([
        getContacts(),
        getAccounts(),
      ]);

      set({
        contacts: Array.isArray(contactData) ? contactData : [],
        accounts: Array.isArray(accountData) ? accountData : [],
        accountsHydrated: true,
        accountsLoading: false,
        accountsError: "",
        hydrated: true,
        loading: false,
        error: "",
      });
    } catch (err) {
      set({
        contacts: [],
        accounts: [],
        accountsHydrated: false,
        accountsLoading: false,
        hydrated: false,
        loading: false,
        error: err?.message || "Failed to hydrate lookup data",
      });
    }
  },

  hydrateAccounts: async ({ force = false } = {}) => {
    if (get().accountsLoading || (get().accountsHydrated && !force)) {
      return;
    }

    set({ accountsLoading: true, accountsError: "" });
    try {
      const accountData = await getAccounts();
      set({
        accounts: Array.isArray(accountData) ? accountData : [],
        accountsHydrated: true,
        accountsLoading: false,
        accountsError: "",
      });
    } catch (err) {
      set({
        accountsLoading: false,
        accountsError: err?.message || "Failed to load accounts",
      });
    }
  },

  setLookups: (lookups) =>
    set((state) => ({
      contacts: lookups.contacts ?? state.contacts,
      accounts: lookups.accounts ?? state.accounts,
      accountsHydrated: lookups.accounts == null ? state.accountsHydrated : true,
      hydrated: true,
      error: "",
    })),

  resetLookups: () =>
    set({
      contacts: [],
      accounts: [],
      accountsHydrated: false,
      accountsLoading: false,
      accountsError: "",
      hydrated: false,
      loading: false,
      error: "",
    }),
}));

export default useLookupStore;
